import { Collapse, Form } from 'antd';
import classNames from 'classnames';
import React from 'react';

import type { ExtranetHotelPack } from 'app/typings/core/extranet/hotel/packs';

import { ScorePanel } from '../../../../Common/Score/_components/ScorePanel/ScorePanel';
import { useEffectiveRoomDiscount } from '../../../hooks/useEffectiveRoomDiscount';
import { usePackPricingScores } from '../../../hooks/usePackPricingScores';
import styles from '../ExperienceDiscount.module.scss';

import { ExperiencesList } from './ExperiencesList';
import { PackHeader } from './PackHeader';
import { RoomDiscountPreview } from './RoomDiscountPreview';

type PackCardProps = {
  pack: ExtranetHotelPack;
  isExpanded: boolean;
  onToggle: () => void;
};

export const PackCard = ({ pack, isExpanded, onToggle }: PackCardProps) => {
  const form = Form.useFormInstance<{
    averageRoomPrice: number;
    defaultNightRoomDiscount: number;
    isDefaultDiscountEnabled: boolean;
  }>();

  const averageRoomPrice = Form.useWatch('averageRoomPrice', form);
  const isDefaultDiscountEnabled = Form.useWatch(
    'isDefaultDiscountEnabled',
    form
  );
  const effectiveRoomDiscount = useEffectiveRoomDiscount();

  const { getPackPricing } = usePackPricingScores();
  const pricing = getPackPricing(pack.id);

  const {
    score: resolvedScore,
    originalPackPrice = 0,
    discountedPackPrice = 0,
    discount = 0,
  } = pricing ?? {};

  return (
    <Collapse
      activeKey={isExpanded ? [pack.id] : []}
      onChange={onToggle}
      ghost
      className={classNames(styles.packCard, { [styles.expanded]: isExpanded })}
    >
      <Collapse.Panel
        key={pack.id}
        header={
          <PackHeader
            pack={pack}
            isExpanded={isExpanded}
            originalPackPrice={originalPackPrice}
            discountedPackPrice={discountedPackPrice}
            discount={discount}
            score={resolvedScore}
            errorMessage={
              !averageRoomPrice
                ? 'Average BAR required'
                : isDefaultDiscountEnabled &&
                    effectiveRoomDiscount === undefined
                  ? 'Discount required'
                  : undefined
            }
          />
        }
        showArrow={false}
      >
        <div className={styles.expandedContent}>
          <div className={styles.wrapper}>
            <p className={styles.sectionTitle}>PRICING SCORE</p>
            <ScorePanel score={resolvedScore} />
          </div>
          <RoomDiscountPreview onToggle={onToggle} />
          <ExperiencesList pack={pack} onToggle={onToggle} />
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};
